import forOwn from 'lodash/forOwn';
import { CancelToken } from 'axios';
// const { CancelToken } = require('axios');
import { makeRequest } from '../../../lib/api';
// import { RefValuesForOfficeRequestInterface } from './offices/officesApi.d';

const PARTNER_PATH = '/v1/partner';
const PARTNER_CONTACT_PATH = '/v1/partner_contact';
const PARTNER_CONTACT_OFFICE_PATH = '/v1/contact_office';
const PARTNER_LEGAL_PATH = '/v1/partner_legal';
const PARTNER_OFFICE_PATH = '/v1/partner_office';
const PARTNER_FIAS = '/v1/fias';
const PARTNER_INSURANCE = '/v1/partner_insurance';
const PARTNER_DIVISION = '/v1/divisions'; // подразделения партнёра
const PARTNER_DIVISION_USERS = '/v1/divisions/users'; // привязка пользователей к подразделениям партнёра
const PARTNER_CORPORATE_EXECUTOR = '/v1/corporate_executor';
const PARTNER_CORPORATE_EXECUTOR_USER = '/v1/corporate_executor_user';
const PARTNER_SERVICE_AVAILABLE_TO_PARTNER = '/v1/services/available_to_partners';
const PARTNER_SERVICE_OFFICE = '/v1/service_office';
const PARTNER_SERVICE_OFFICE_REF_VALUE = '/v1/service_office_ref_value';
const PARTNER_DOC_TEMPLATE = '/v1/partner_doc_templates';
const PARTNER_OFFICE_CORPORATE_PARTNER_PATH = '/v1/office_corporate_partner';
const PARTNER_OFFICE_USER = '/v1/office_user';
const PARTNER_OFFICE_DOMAIN = '/v1/partner_office_domain';
const PARTNER_EVACUATION_VEHICLE = '/v1/evacuation';

class partnerController {
  /** блок crud партнёров */
  getPartnerList = (param1, param2) => {
    // Гибкая обработка для обратной совместимости:
    // Поддерживает как вызов с объектом: getPartnerList({ serviceId, hasTBankRegistration })
    // Так и вызов с двумя отдельными параметрами: getPartnerList(serviceId, hasTBankRegistration)
    let serviceId;
    let hasTBankRegistration;

    if (typeof param1 === 'object' && param1 !== null && !Array.isArray(param1)) {
      serviceId = param1.serviceId;
      hasTBankRegistration = param1.hasTBankRegistration;
    } else {
      serviceId = param1;
      hasTBankRegistration = param2;
    }

    const queryParams = new URLSearchParams();

    if (serviceId !== undefined && serviceId !== null && serviceId !== '') {
      queryParams.append('serviceId', serviceId);
    }

    // Передаем на бэк только если значение строго true или false
    if (hasTBankRegistration === true || hasTBankRegistration === false) {
      queryParams.append('hasTBankRegistration', hasTBankRegistration);
    }

    const queryString = queryParams.toString();
    const url = queryString ? `${ PARTNER_PATH }?${ queryString }` : PARTNER_PATH;

    return makeRequest('get', url);
  };

  getPartnerListByArray = (params) => {
    return makeRequest('post', `${ PARTNER_PATH }/find`, params);
  };

  getPartner = (id) => {
    return makeRequest('get', `${ PARTNER_PATH }/${ id }`);
  };

  checkDomainFree = (domain) => {
    return makeRequest('get', `${ PARTNER_PATH }/domain_free?domain=${ domain }`);
  };

  createPartner = (data = {}) => {
    return makeRequest('post', `${ PARTNER_PATH }`, data);
  };

  updatePartner = (data = {}) => {
    return makeRequest('put', `${ PARTNER_PATH }/${ data.id }`, data);
  };

  deletePartner = (id) => {
    return makeRequest('put', `${ PARTNER_PATH }/${ id }`);
  };

  setLogo = (file, partnerId) => {
    const form = new FormData();
    form.append('image', file);

    return makeRequest('post', `${ PARTNER_PATH }/${ partnerId }/avatar`, form);
  };

  getLogo = () => {
    return makeRequest('get', `${ PARTNER_PATH }/logo`);
  };

  /** блок crud контактов партнёра */
  getPartnerContactList = (data = {}) => {
    return makeRequest('get', `${ PARTNER_CONTACT_PATH }`, data);
  };

  getPartnerContact = (id) => {
    return makeRequest('get', `${ PARTNER_CONTACT_PATH }/${ id }`);
  };

  createPartnerContact = (data = {}) => {
    return makeRequest('post', `${ PARTNER_CONTACT_PATH }`, data);
  };

  updatePartnerContact = (data = {}) => {
    return makeRequest('put', `${ PARTNER_CONTACT_PATH }/${ data.id }`, data);
  };

  deletePartnerContact = (id) => {
    return makeRequest('delete', `${ PARTNER_CONTACT_PATH }/${ id }`);
  };

  /** блок crud физ. лиц партнёра */
  getPartnerLegalList = (data = {}) => {
    return makeRequest('get', `${ PARTNER_LEGAL_PATH }`, data);
  };

  getPartnerLegal = (id) => {
    return makeRequest('get', `${ PARTNER_LEGAL_PATH }/${ id }`);
  };

  getPartnerLegalByPartnerId = (id) => {
    return makeRequest('get', `${ PARTNER_LEGAL_PATH }/${ id }/partner`);
  };

  createPartnerLegal = (data = {}) => {
    return makeRequest('post', `${ PARTNER_LEGAL_PATH }`, data);
  };

  updatePartnerLegal = (data = {}) => {
    return makeRequest('put', `${ PARTNER_LEGAL_PATH }/${ data.id }`, data);
  };

  deletePartnerLegal = (id) => {
    return makeRequest('delete', `${ PARTNER_LEGAL_PATH }/${ id }`);
  };

  getPartnerLegalFiles(data) {
    return makeRequest('get', `${ PARTNER_LEGAL_PATH }/${ data.partnerLegalId }/files?showDeleted=${ data.showDeleted || false }`);
  }

  addPartnerLegalFile(data) {
    const { partnerLegalId, ...rest } = data;
    const form = new FormData();
    forOwn(rest, (value, key) => {
      form.append(key, value);
    });
    return makeRequest('post', `${ PARTNER_LEGAL_PATH }/${ partnerLegalId }/files`, form);
  }

  deletePartnerLegalFile(data) {
    return makeRequest('delete', `${ PARTNER_LEGAL_PATH }/files/${ data.fileId }`);
  }

  /** блок crud офисов партнёра */
  getPartnerOfficeList = (data) => {
    const p1 = data?.partnerId ? `&partnerId=${ data.partnerId }` : '';
    const p2 = data?.serviceId ? `${ p1 }&serviceId=${ data.serviceId }` : p1;
    const p3 = data?.schedulerClassifierRefValueId 
      ? `${ p2 }&schedulerClassifierRefValueId=${ data.schedulerClassifierRefValueId }` 
      : p2;
    return makeRequest('get', `${ PARTNER_OFFICE_PATH }?showDeleted=${ data.showDeleted || false }${ p3 }`);
  };

  createPartnerOffice = (data = {}) => {
    return makeRequest('post', `${ PARTNER_OFFICE_PATH }`, data);
  };

  updatePartnerOffice = (data = {}) => {
    return makeRequest('put', `${ PARTNER_OFFICE_PATH }/${ data.id }`, data);
  };

  deletePartnerOffice = (id) => {
    return makeRequest('delete', `${ PARTNER_OFFICE_PATH }/${ id }`);
  };

  restorePartnerOffice = (id) => {
    return makeRequest('post', `${ PARTNER_OFFICE_PATH }/${ id }`);
  };

  getPartnerOfficesForService = (serviceId, showDeleted) => {
    const p0 = showDeleted ? '&showDeleted=true' : '&showDeleted=false';
    return makeRequest('get', `${ PARTNER_SERVICE_OFFICE }/offices?serviceId=${ serviceId }${ p0 }`);
  };

  getPartnerOfficesForServiceAndPartner = (serviceId, partnerId, showDeleted = false ) => {
    const p0 = showDeleted ? '&showDeleted=true' : '&showDeleted=false';
    return makeRequest('get', `${ PARTNER_SERVICE_OFFICE }/offices?serviceId=${ serviceId }&partnerId=${ partnerId }${ p0 }`);
  };

  /** блок привязки контактов к офисам */
  getPartnerContactOffice = (partnerContactId) => {
    return makeRequest('get', `${ PARTNER_CONTACT_OFFICE_PATH }/partner_contact/${ partnerContactId }`);
  };

  createPartnerContactOffice = (data = {}) => {
    return makeRequest('post', `${ PARTNER_CONTACT_OFFICE_PATH }`, data);
  };

  deletePartnerContactOffice = (contactOfficeId) => {
    return makeRequest('delete', `${ PARTNER_CONTACT_OFFICE_PATH }/${ contactOfficeId }`);
  };

  /** блок привязки ФИАС к партнёрам */

  regionSearchCancelToken = null;

  getFiasRegionsSearch = (data) => {
    if (this.regionSearchCancelToken) {
      this.regionSearchCancelToken();
    }

    this.regionRequest = makeRequest(
      'post',
      `${ PARTNER_FIAS }/search/regions`,
      data,
      {
        cancelToken: new CancelToken(c => {
          this.regionSearchCancelToken = c;
        }),
      }
    );
    return this.regionRequest;
  };

  getFiasByFiasId = (fiasId) => {
    return makeRequest('get', `${ PARTNER_FIAS }/${ fiasId }`);
  };

  getFiasRegionsPartner = (partnerId) => {
    return makeRequest('get', `${ PARTNER_FIAS }/bindings/partners/${ partnerId }`);
  };

  getFiasRegionsUser = (userId) => {
    return makeRequest('get', `${ PARTNER_FIAS }/bindings/users/${ userId }`);
  };

  createFiasBinding = (data) => {
    return makeRequest('post', `${ PARTNER_FIAS }/bindings`, data);
  };

  deleteFiasBinding = (fiasBindingId) => {
    return makeRequest('delete', `${ PARTNER_FIAS }/bindings/${ fiasBindingId }`);
  };

  /** блок привязки страховых к партнёрам */
  // список привязок по партнёру
  getPartnerInsurance = (partnerId) => {
    return makeRequest('get', `${ PARTNER_INSURANCE }/partners/${ partnerId }`);
  };

  // сделать привязку страховой компании к партнёру
  createPartnerInsurance = (data = {}) => {
    return makeRequest('post', `${ PARTNER_INSURANCE }`, data);
  };

  updatePartnerInsurance = (data = {}) => {
    return makeRequest('put', `${ PARTNER_INSURANCE }/${ data.id }`, data);
  };

  // удалить привязку страховой компании к партнёру
  deletePartnerInsurance = (partnerInsuranceId) => {
    return makeRequest('delete', `${ PARTNER_INSURANCE }/${ partnerInsuranceId }`);
  };

  // список привязок страховых компаний по связке сервис-офис
  // Используется в карточке офиса
  getPartnerInsuranceByServiceOfficeId = (serviceOfficeId) => {
    return makeRequest('get', `${ PARTNER_INSURANCE }/companies/service_office/${ serviceOfficeId }`);
  };

  /** блок управления подразделениями партнёра партнёрам */
  getPartnerDivision = (partnerId) => {
    return makeRequest('get', partnerId ? `${ PARTNER_DIVISION }/?partnerId=${ partnerId }` : `${ PARTNER_DIVISION }`);
  };

  createPartnerDivision = (data = {}) => {
    return makeRequest('post', `${ PARTNER_DIVISION }`, data);
  };

  updatePartnerDivision = (data = {}) => {
    return makeRequest('put', `${ PARTNER_DIVISION }/${ data.id }`, data);
  };

  deletePartnerDivision = (divisionId) => {
    return makeRequest('delete', `${ PARTNER_DIVISION }/${ divisionId }`);
  };

  /** блок привязки пользователей к подразделениям партнёра  */
  getPartnerDivisionUser = (userId) => {
    return makeRequest('get', `${ PARTNER_DIVISION_USERS }/${ userId }`);
  };

  createPartnerDivisionUser = (data = {}) => {
    return makeRequest('post', `${ PARTNER_DIVISION_USERS }`, data);
  };

  // Делаем подразделение главным !!
  putPartnerDivisionUser = (data = {}) => {
    return makeRequest('put', `${ PARTNER_DIVISION_USERS }`, data);
  };

  deletePartnerDivisionUser = (data) => {
    return makeRequest('delete', `${ PARTNER_DIVISION_USERS }`, data);
  };

  // список подразделений, куда входит аутентифицированный пользователь
  getPartnerDivisionByAuth = () => {
    return makeRequest('get', `${ PARTNER_DIVISION_USERS }`);
  };

  // /v1/divisions/{divisionId}/users  Возвращает список сотрудников, входящих в заданное подразделение
  getUsersByDivision = (divisionId, onlyPrimary) => {
    return makeRequest('get', `${ PARTNER_DIVISION }/${ divisionId }/users${ onlyPrimary ? '?primary=true' : '' }`);
  };

  // Возвращает список сотрудников не удаленных подразделений,
  // в которые входит аутентифицированный пользователь
  getAuthUserDivisionsColleagues = (primary) => {
    const param = primary ? '?primary=true' : '?primary=false';
    return makeRequest('get', `${ PARTNER_DIVISION_USERS }/colleagues${ primary === undefined ? '' : param }`);
  };
  /** конец блок привязки пользователей к подразделениям партнёра */

  /** блок Управления привязками корп. клиентов, партнеров-исполнителей и сервисов  */
  getPartnerCorporateExecutor = (data) => {
    return makeRequest('get', `${ PARTNER_CORPORATE_EXECUTOR }?executorPartnerId=${ data.executorPartnerId }`);
  };

  createPartnerCorporateExecutor = (data = {}) => {
    return makeRequest('post', `${ PARTNER_CORPORATE_EXECUTOR }`, data);
  };

  restorePartnerCorporateExecutor = (id) => {
    return makeRequest('put', `${ PARTNER_CORPORATE_EXECUTOR }/${ id }/restore`);
  };

  deletePartnerCorporateExecutor = (id) => {
    return makeRequest('delete', `${ PARTNER_CORPORATE_EXECUTOR }/${ id }`);
  };

  getPartnerCorporateExecutorUser = (corporateExecutorId) => {
    return makeRequest('get', `${ PARTNER_CORPORATE_EXECUTOR_USER }?corporateExecutorId=${ corporateExecutorId }`);
  };

  createPartnerCorporateExecutorUser = (data = {}) => {
    return makeRequest('post', `${ PARTNER_CORPORATE_EXECUTOR_USER }`, data);
  };

  deletePartnerCorporateExecutorUser = (data) => {
    return makeRequest('delete', `${ PARTNER_CORPORATE_EXECUTOR_USER }?corporateExecutorId=${ data.corporateExecutorId }&userId=${ data.userId }`);
  };

  // список сервисов, доступных корпоративному клиенту и партнёру
  getPartnerServicesAvailableToPartners = (data = {}) => {
    return makeRequest('get', `${ PARTNER_SERVICE_AVAILABLE_TO_PARTNER }?corporatePartnerId=${ data.corporatePartnerId }&executorPartnerId=${ data.executorPartnerId }`);
  };

  // Возвращает список активных не удаленных партнеров типа "корпоративный клиент"
  getPartnerCorporateClients = () => {
    return makeRequest('get', `${ PARTNER_PATH }/corporate_clients`);
  };
    /** конец блока Управления привязками корп. клиентов, партнеров-исполнителей и сервисов  */

  /** блок Управления привязками  сервисов к офисам  */
  getPartnerOfficeServices = (partnerOfficeId) => {
    return makeRequest('get', `${ PARTNER_SERVICE_OFFICE }/services?partnerOfficeId=${ partnerOfficeId }`);
  };

  getPartnerOfficeService = (serviceOfficeId) => {
    return makeRequest('get', `${ PARTNER_SERVICE_OFFICE }/${ serviceOfficeId }`);
  };

  createPartnerOfficeService = (data = {}) => {
    return makeRequest('post', `${ PARTNER_SERVICE_OFFICE }`, data);
  };

  updatePartnerOfficeService = (data) => {
    return makeRequest('put', `${ PARTNER_SERVICE_OFFICE }/${ data.id }`, { ...data, emails: data?.emails, priceListId: data?.priceListId });
  };

  deletePartnerOfficeService = (id) => {
    return makeRequest('delete', `${ PARTNER_SERVICE_OFFICE }/${ id }`);
  };

  // метод возвращает по офису и сервису данные связки сервис-офис
  // используется в журнале записи для получения supportsRunflatTires
  getPartnerOfficeServiceByOfficeAndService = (data) => {
    return makeRequest('get', `${ PARTNER_SERVICE_OFFICE }?partnerOfficeId=${ data.partnerOfficeId }&serviceId=${ data.serviceId }`);
  };
  /**  конец блока Управления привязками  сервисов к офисам  */

  /** фото офиса партнера */
  addPartnerOfficePhotos = ({ officeId, ...rest }) => {
    const form = new FormData();
    forOwn(rest, (value, key) => {
      form.append(key, value);
    });
    return makeRequest('post', `${ PARTNER_OFFICE_PATH }/${ officeId }/photos`, form);
  };

  getPartnerOfficePhotos = (id) => {
    return makeRequest('get', `${ PARTNER_OFFICE_PATH }/${ id }/photos`);
  };

  updatePartnerOfficePhoto = ({ id, ...rest }) => {
    return makeRequest('put', `${ PARTNER_OFFICE_PATH }/photos/${ id }`, rest);
  };

  deletePartnerOfficePhoto = (data) => {
    return makeRequest('delete', `${ PARTNER_OFFICE_PATH }/photos/${ data.id }`, data);
  };
  /** конец блока фото офиса партнера */

  /** блок для сервис-офисов-refValues в карточке Service-Office: */
  getServiceOfficeRefValues = (serviceOfficeId) => {
    return makeRequest('get', `${ PARTNER_SERVICE_OFFICE_REF_VALUE }?serviceOfficeId=${ serviceOfficeId }`);
  };

  createServiceOfficeRefValues = (data) => {
    return makeRequest('post', `${ PARTNER_SERVICE_OFFICE_REF_VALUE }`, data);
  };

  deleteServiceOfficeRefValues = (id) => {
    return makeRequest('delete', `${ PARTNER_SERVICE_OFFICE_REF_VALUE }/${ id }`);
  };

  //  getRefValuesForOffice = (request:RefValuesForOfficeRequestInterface) => {
  getRefValuesForOffice = (request) => {
    return makeRequest('get', `${ PARTNER_SERVICE_OFFICE_REF_VALUE }/ref_values?partnerOfficeId=${ request.partnerOfficeId }&refId=${ request.refId }&serviceId=${ request.serviceId }`);
  };

  /** конец блока фото офиса партнера */

  /** блок для шаблонов документов: */
  getDocTemplates = (request) => {
    const p0 = request?.showDeleted ? 'showDeleted=true' : 'showDeleted=false';
    const p1 = request?.partnerId ? `${ p0 }&partnerId=${ request.partnerId }` : p0;

    const p2 = request?.docTypeRefValueId ? `${ p1 }&serviceId=${ request.docTypeRefValueId }` : p1;
    return makeRequest('get', `${ PARTNER_DOC_TEMPLATE }?${ p2 }`);
  };

  createDocTemplates(data) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { partnerLegalId, ...rest } = data;
    const form = new FormData();
    forOwn(rest, (value, key) => {
      // undefined/null не кладём: FormData превратит их в строку "undefined"/"null",
      // и бэк упадёт на конверсии (напр. kitRefValueId -> Long). Пустую строку слать можно.
      if (value !== undefined && value !== null) {
        form.append(key, value);
      }
    });
    return makeRequest('post', `${ PARTNER_DOC_TEMPLATE }`, form);
  }

  deleteDocTemplates = (id) => {
    return makeRequest('delete', `${ PARTNER_DOC_TEMPLATE }/${ id }`);
  };

  restoreDocTemplates = (id) => {
    return makeRequest('post', `${ PARTNER_DOC_TEMPLATE }/${ id }`);
  };

  updateDocTemplates(data) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { partnerLegalId, ...rest } = data;
    const form = new FormData();
    forOwn(rest, (value, key) => {
      // undefined/null не кладём: FormData превратит их в строку "undefined"/"null",
      // и бэк упадёт на конверсии (напр. kitRefValueId/storedObjectRefValueId -> Long). Пустую строку слать можно.
      if (value !== undefined && value !== null) {
        form.append(key, value);
      }
    });
    return makeRequest('post', `${ PARTNER_DOC_TEMPLATE }/${ data.id }/update`, form);
  }

  getDocTemplateFonts = () => { // получение списка установленных шрифтов на сервере
    return makeRequest('get', `${ PARTNER_DOC_TEMPLATE }/fonts`);
  };

  // прокси файла шаблона из S3 (тот же origin) — для предпросмотра/редактирования PDF на фронте
  getDocTemplateFile = (id) => {
    return makeRequest('get', `${ PARTNER_DOC_TEMPLATE }/${ id }/file`, {}, { responseType: 'arraybuffer' });
  };

  /** конец блока шаблонов документов */

  /** блок для корпоративных партнёров офисов: */
  getOfficeCorporatePartners = (request) => {
    const p0 = request?.showDeleted ? 'showDeleted=true' : 'showDeleted=false';
    const p1 = request?.officeId ? `${ p0 }&officeId=${ request.officeId }` : `${ p0 }`;
    return makeRequest('get', `${ PARTNER_OFFICE_CORPORATE_PARTNER_PATH }?${ p1 }`);
  };

  createOfficeCorporatePartner(data) {
    return makeRequest('post', `${ PARTNER_OFFICE_CORPORATE_PARTNER_PATH }`, data);
  }

  updateOfficeCorporatePartner(data) {
    return makeRequest('put', `${ PARTNER_OFFICE_CORPORATE_PARTNER_PATH }/${ data.id }`, data);
  }

  deleteOfficeCorporatePartner = (id) => {
    return makeRequest('delete', `${ PARTNER_OFFICE_CORPORATE_PARTNER_PATH }/${ id }`);
  };

  restoreOfficeCorporatePartner = (id) => {
    return makeRequest('post', `${ PARTNER_OFFICE_CORPORATE_PARTNER_PATH }/${ id }`);
  };

  /** конец блока для корпоративных партнёров офисов */

  /** блок для связки  офис - user */
  getUserByOffice = (officeId) => {
    return makeRequest('get', `${ PARTNER_OFFICE_USER }/by_office?officeId=${ officeId }`);
  };

  createUserByOffice(data) {
    return makeRequest('post', `${ PARTNER_OFFICE_USER }`, data);
  }

  deleteUserByOffice = (id) => {
    return makeRequest('delete', `${ PARTNER_OFFICE_USER }/${ id }`);
  };
  /** конец блока для  связки  офис - user */

  /** блок для доменов офисов */
  getPartnerOfficeDomains = (officeId) => {
    return makeRequest('get', `${ PARTNER_OFFICE_DOMAIN }/by_office?partnerOfficeId=${ officeId }`);
  };

  createPartnerOfficeDomain(data) {
    return makeRequest('post', `${ PARTNER_OFFICE_DOMAIN }?partnerOfficeId=${ data.partnerOfficeId }&domain=${ data.domain }`);
  }

  deletePartnerOfficeDomain = (id) => {
    return makeRequest('delete', `${ PARTNER_OFFICE_DOMAIN }?id=${ id }`);
  };

  getUniqueDomains = () => {
    return makeRequest('get', `${ PARTNER_OFFICE_DOMAIN }/unique`);
  };
  /** конец блока для доменов офисов */

  /** автопарк партнёра (эвакуаторы) */
  getPartnerVehicle = (id) => {
    return makeRequest('get', `${ PARTNER_EVACUATION_VEHICLE }/vehicle?id=${ id }`);
  };

  getPartnerCarPark = (partnerId,showDeleted) => {
    const showDeletedString = showDeleted ? '&showDeleted=true' : '';
    return makeRequest('get', `${ PARTNER_EVACUATION_VEHICLE }/vehicle_by_partner?partnerId=${ partnerId }${ showDeletedString }`);
  };

  createNewCarParkVehicle(request) {
    return makeRequest('post', `${ PARTNER_EVACUATION_VEHICLE }/vehicle`, request);
  }

  updateCarParkVehicle(request) {
    return makeRequest('put', `${ PARTNER_EVACUATION_VEHICLE }/vehicle?vehicleId=${ request?.id }`, request);
  }

  deleteCarParkVehicle = (id) => {
    return makeRequest('delete', `${ PARTNER_EVACUATION_VEHICLE }/vehicle?vehicleId=${ id }`);
  };

  getCommercialVehicleMakes = () => {
    return makeRequest('get', `${ PARTNER_EVACUATION_VEHICLE }/vehicle/make`);
  };

  getCommercialVehicleModels = (makeId) => {
    return makeRequest('get', `${ PARTNER_EVACUATION_VEHICLE }/vehicle/model?makeId=${ makeId }`);
  };

  /** конец блока автопарк партнёра (эвакуаторы) */

  // регистрация партнёра в Т-Банке для мультиплатежей
  startRegister = (patnerLegalId) => {
    return makeRequest('post', `${ PARTNER_LEGAL_PATH }/${ patnerLegalId }/tbank-register`, {});
  };

}

export default new partnerController();
